import './index.scss';
import Layer from './layer';

export default config => new Layer(config);
